import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute'

import DatasourceFormLayout from './containers/Form';
import DatasourcesGridLayout from './containers/Grid'

export default function DatasourceLayout() {
  return <Router>
    <PrivateRoute exact path="/settings/datasources" component={DatasourcesGridLayout} />
    <PrivateRoute path={["/settings/datasources/add", "/settings/datasources/:id"]} component={DatasourceFormLayout} />
  </Router>
}
